import React from 'react'
import PropTypes from 'prop-types'
import { ArrowIcon } from '@argos/icons'

import { megaMenuLevelOneUrlBuilder } from '../../helpers/analyticsUrlBuilder'
import config from '../../config/config'

import styles from './MegaMenuCategories.scss'

const MegaMenuCategories = ({
  taxonomy,
  activeCategory,
  onSetRef,
  isFallbackMenu,
  onClick,
  onBackButtonClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  let isDesktop = false
  if (global && global.innerWidth >= config.breakpoints.xl) {
    isDesktop = true
  }
  const ariaLabel = (category) =>
    `To hear more ${
      category.title
    } links, please hit the spacebar key to enter the menu. Or click here to go to all of ${category.title}.`
  return (
    <li className={'mega-menu-column'} data-menulevel={1} data-fallback-menu={isFallbackMenu}>
      <ul className={styles.menu} data-el={`level-1`} data-submenu-active={activeCategory.index}>
        {/* Mobile Back Button */}
        <li className={`${styles.category} ${styles.menuItem} ${styles.back}`}>
          <a
            aria-haspopup={false}
            href={'/'}
            tabIndex={0}
            className={styles.link}
            data-megamenu-link
            data-test={'megamenu-back-to-categories'}
            onClick={onBackButtonClick}>
            <ArrowIcon dir='left' className={styles.arrow} />
            {`Back to Categories`}
          </a>
        </li>
        <ul className={styles.scrollableArea}>
          {taxonomy.map((category, idx) => (
            <li
              key={`${category.title}-${idx}`}
              className={`${styles.category} ${styles.menuItem} ${
                category.columns.length === 0 ? styles.seasonal : ''
              }`}>
              <a
                aria-label={isDesktop && ariaLabel(category)}
                aria-expanded={activeCategory.index === idx}
                tabIndex={0}
                className={`${styles.link} ${category.columns.length === 0 ? styles.seasonal : ''}`}
                ref={(ref) => onSetRef(ref, idx)}
                data-megamenu-link
                data-test={`megamenu-category-${idx}`}
                onClick={(evt) => onClick(idx, category, evt)}
                onTouchStart={(evt) => onClick(idx, category, evt)}
                onKeyDown={(evt) => onClick(idx, category, evt)}
                onMouseEnter={(evt) => onMouseEnter(idx, category, evt)}
                onMouseLeave={onMouseLeave}
                href={`${category.link}${megaMenuLevelOneUrlBuilder(category.link)}`}>
                {category.title}
              </a>
              {!(taxonomy.length === idx + 1) && (
                <span
                  aria-hidden={true}
                  className={styles.hoverExclusionZone}
                  onMouseEnter={(evt) => onMouseEnter(idx, category, evt)}
                  onMouseLeave={onMouseLeave}
                />
              )}
            </li>
          ))}
        </ul>
      </ul>
    </li>
  )
}

MegaMenuCategories.propTypes = {
  activeCategory: PropTypes.shape({
    index: PropTypes.number,
    text: PropTypes.string,
    link: PropTypes.string,
  }),
  isFallbackMenu: PropTypes.bool,
  onBackButtonClick: PropTypes.func,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onSetRef: PropTypes.func,
  taxonomy: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string,
      columns: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            links: PropTypes.arrayOf(
              PropTypes.shape({
                link: PropTypes.string,
                title: PropTypes.string,
              }),
            ),
          }),
        ),
      ),
    }),
  ),
}

MegaMenuCategories.defaultProps = {
  taxonomy: [],
  activeCategory: {
    index: null,
  },
  isFallbackMenu: false,
  onSetRef: () => {},
  onClick: () => {},
  onBackButtonClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
}

export default MegaMenuCategories
